module.exports = __webpack_public_path__ + "img/activity_icon.8049ed9.png";